import { createApp } from 'vue'
import router from "@/router/router";

async function init() {
    // Check if we have exhibitors admin container
    const exhibitorsAppContainer = document.getElementById('exhibitors-app');
    if (exhibitorsAppContainer) {
        const { default: ExhibitorManagement } = await import(/* webpackChunkName: "exhibitors-admin-chunk" */ "@/components/admin/ExhibitorManagement.vue");
        
        const app = createApp(ExhibitorManagement);
        
        // Set the language for the texts
        window.rvr_admin = window.rvr_admin || {};
        window.rvr_admin.lang = 'nl';
        
        app.mount('#exhibitors-app');
        return;
    }

    // Check if we have exhibitors list configuration (development mode)
    if (window.rvr_public && window.rvr_public.exhibitors_list_config) {
        const config = window.rvr_public.exhibitors_list_config;
        const containerId = config.instance_id || 'exhibitors-list-default';
        
        // Find the container element
        const container = document.getElementById(containerId);
        if (container) {
            const { default: PublicExhibitorsList } = await import(/* webpackChunkName: "public-dashboard" */ "@/components/public/PublicExhibitorsList.vue");
            
            const app = createApp(PublicExhibitorsList, {
                initialSortBy: config.initial_sort_by || 'company_name',
                initialSortOrder: config.initial_sort_order || 'asc'
            });
            
            // Set the language for the texts
            window.rvr_public = window.rvr_public || {};
            window.rvr_public.lang = config.lang || 'nl';
            
            app.mount(`#${containerId}`);
            return;
        }
    }

    // Regular app initialization
    let App;
    if (window.rbs_vr_object && window.rbs_vr_object.isAdmin) {
        const { default: AdminDashboard } = await import(/* webpackChunkName: "admin-dashboard" */ "@/components/admin/AdminDashboard.vue");
        App = AdminDashboard;
    } else {
        const { default: PublicDashboard } = await import(/* webpackChunkName: "public-dashboard" */ "@/components/public/PublicDashboard.vue");
        App = PublicDashboard;
    }

    // Only mount the main app if the #app element exists
    const appElement = document.getElementById('app');
    if (appElement) {
        const app = createApp(App).use(router).mount('#app');
        global.vuedata = app.$data.jquery_editable;
    }
}

init();
